// Generic CSV download utilities for Prefix analytics charts
// Works with endpoints that return a `download_data` field (array of objects or arrays)

function escapeCsv(val) {
  if (val == null) return '';
  const s = String(val);
  if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

function detectColumnsFromObjects(rows) {
  if (!rows || !rows.length || typeof rows[0] !== 'object') return [];
  const keys = Object.keys(rows[0]);
  return keys.map(k => ({ key: k, label: k }));
}

function normalizeDownloadData(downloadData, opts = {}) {
  const { columns, transformRow } = opts;
  if (!Array.isArray(downloadData)) return { headers: [], rows: [] };

  // Array of objects
  if (downloadData.length && typeof downloadData[0] === 'object' && !Array.isArray(downloadData[0])) {
    const cols = (columns && columns.length) ? columns : detectColumnsFromObjects(downloadData);
    const headers = cols.map(c => c.label || c.key);
    const rows = downloadData.map(obj => {
      const source = typeof transformRow === 'function' ? transformRow(obj) : obj;
      return cols.map(c => source[c.key]);
    });
    return { headers, rows };
  }

  // Array of arrays
  if (downloadData.length && Array.isArray(downloadData[0])) {
    const headers = (columns && columns.length) ? columns.map(c => c.label || c.key || c) : [];
    const rows = downloadData;
    return { headers, rows };
  }

  return { headers: [], rows: [] };
}

export function buildCsvString(headers, rows) {
  const lines = [];
  if (headers && headers.length) lines.push(headers.map(escapeCsv).join(','));
  for (const r of rows) lines.push((Array.isArray(r) ? r : Object.values(r)).map(escapeCsv).join(','));
  return lines.join('\n');
}

export function triggerCsvDownload(csvString, filename = 'CoHost_Analytics_Data.csv') {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function downloadChartCsv({ endpoint, params, filename, dataPath = 'download_data', columns, transformRow } = {}) {
  const url = `${endpoint}?${params.toString()}`;
  const res = await fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
  if (!res.ok) throw new Error(`CSV fetch failed ${res.status}`);
  const data = await res.json();
  const downloadData = data && data[dataPath] ? data[dataPath] : (data && data.chart_data ? data.chart_data : []);
  const { headers, rows } = normalizeDownloadData(downloadData, { columns, transformRow });
  const csv = buildCsvString(headers, rows);
  triggerCsvDownload(csv, filename);
}

